import Phaser from 'phaser';

import Preloader from './scenes/Preloader';
import Game from './scenes/Game';
import Menu from './scenes/Menu';
import Start from './scenes/Start';
import { mapSize, tileSize } from './consts/sizes';
import { DEBUG, FPS } from './consts/config';


const config: Phaser.Types.Core.GameConfig = {
	type: Phaser.AUTO,
	width: mapSize.x * tileSize,
	height: mapSize.y * tileSize,
	input: {
		gamepad: true
	},
	physics: {
		default: 'arcade',
		arcade: {
			gravity: { y: 0 },
			debug: DEBUG,
			fps: FPS
		}
	},
	fps: {
		min: FPS,
		target: FPS,
	},
	parent: document.getElementById('kebab') as HTMLCanvasElement,
	scale: {
		mode: Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH,
		autoCenter: Phaser.Scale.CENTER_BOTH
	},
	pixelArt: true,
	scene: [
		Preloader,
		Menu,
		Start,
		Game,
	],
};

export default new Phaser.Game(config);
